import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    class: "postCard",
    "data-post-card": ""
};
const _hoisted_2 = ["href", "title", "target", "rel"];
const _hoisted_3 = {
    key: 0,
    class: "h3 !mb-0 !font-bold"
};
import ImageLandscape from '@atoms/ImageLandscape.vue';
import ButtonWithArrow from '@atoms/ButtonWithArrow.vue';
import { computed } from 'vue';
import { decodeHTML } from '@helpers/text';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuickLinkCard',
    props: {
        post: {
            type: Object,
            required: true,
        },
        displayOptions: {
            type: Array,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const displayTitle = computed(() => {
            return props.displayOptions.includes('title');
        });
        const postTitle = computed(() => {
            if (displayTitle.value) {
                return props.post.title;
            }
            return 'Read more';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("article", _hoisted_1, [
                _createElementVNode("a", {
                    href: __props.post.url,
                    title: `Read more about ${__props.post.title}`,
                    class: "group flex scroll-ml-3 flex-col gap-7",
                    target: __props.post.target,
                    rel: __props.post.target === '_blank' ? 'noopener noreferrer' : null
                }, [
                    (!displayTitle.value)
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_unref(decodeHTML)(__props.post.title)), 1))
                        : _createCommentVNode("", true),
                    (__props.post.image && __props.post.image.url)
                        ? (_openBlock(), _createBlock(ImageLandscape, {
                            key: 1,
                            image: __props.post.image
                        }, null, 8, ["image"]))
                        : _createCommentVNode("", true),
                    _createVNode(ButtonWithArrow, {
                        target: __props.post.target,
                        text: postTitle.value,
                        url: __props.post.url
                    }, null, 8, ["target", "text", "url"])
                ], 8, _hoisted_2)
            ]));
        };
    }
});
